<template>
  <div>
    <div class="home">
      <a-row :gutter="60" class="zhuanti" type="flex" justify="space-between">
        <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <router-link :to="{path: '/event/list'}">
            <ImageButton
              class="zhuanti-item animate__animated animate__fadeIn"
              text="参测报名" fontSize="1.5rem" width="250px" height="72px"
              :bg-image="require('@assets/theme/aice/card-btn.png')"
              :hover-bg-image="require('@assets/theme/aice/card-btn-hover.png')"/>
          </router-link>
        </a-col>
        <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <router-link :to="{path: '/cert/query'}">
            <ImageButton
              class="zhuanti-item animate__animated animate__fadeIn"
              text="证书/成绩查询" fontSize="1.5rem" width="250px" height="72px"
              :bg-image="require('@assets/theme/aice/card-btn.png')"
              :hover-bg-image="require('@assets/theme/aice/card-btn-hover.png')"/>
          </router-link>
        </a-col>
        <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <router-link :to="{path: '/user/event'}">
            <ImageButton
              class="zhuanti-item animate__animated animate__fadeIn"
              text="进入测评" fontSize="1.5rem" width="250px" height="72px"
              :bg-image="require('@assets/theme/aice/card-btn.png')"
              :hover-bg-image="require('@assets/theme/aice/card-btn-hover.png')"/>
          </router-link>
        </a-col>
        <a-col :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <a href="https://e.aice.org.cn/event/detail?id=1664248031578443778" target="_blank">
            <ImageButton
              class="zhuanti-item animate__animated animate__fadeIn"
              text="高校营地报名" fontSize="1.5rem" width="250px" height="72px"
              :bg-image="require('@assets/theme/aice/card-btn.png')"
              :hover-bg-image="require('@assets/theme/aice/card-btn-hover.png')"/>
          </a>
        </a-col>
      </a-row>
      <a-row type="flex" justify="space-between">
        <a-col
          :gutter="20"
          :xs="24" :sm="24" :md="24" :lg="15" :xl="15"
          class="animate__animated animate__bounceInLeft"
        >
          <a-card
            class="column-card box-shadow"
            :bordered="false"
            style="min-height: 430px"
          >
            <a-tabs default-active-key="1" @change="getCmsList">
              <a-tab-pane key="1" tab="文件通知">
                <a-list :dataSource="cmsDataSource">
                  <a-list-item
                    class="cms-item"
                    slot="renderItem"
                    slot-scope="item"
                    @click="toCmsDetail(item)"
                  >
                    <span class="cms-title">{{ item.cmsTitile }}</span>
                    <span class="cms-time">{{ item.createTime.split(" ")[0] }}</span>
                  </a-list-item>
                </a-list>
              </a-tab-pane>
              <a-tab-pane key="2" tab="新闻报道">
                <a-list :dataSource="cmsDataSource">
                  <a-list-item
                    class="cms-item"
                    slot="renderItem"
                    slot-scope="item"
                    @click="toCmsDetail(item)"
                  >
                    <span class="cms-title">{{ item.cmsTitile }}</span>
                    <span class="cms-time">{{ item.createTime.split(" ")[0] }}</span>
                  </a-list-item>
                </a-list>
              </a-tab-pane>
              <a-tab-pane key="3" tab="共建示范校">
                <a-list :dataSource="cmsDataSource">
                  <a-list-item
                    class="cms-item"
                    slot="renderItem"
                    slot-scope="item"
                    @click="toCmsDetail(item)"
                  >
                    <span class="cms-title">{{ item.cmsTitile }}</span>
                    <span class="cms-time">{{ item.createTime.split(" ")[0] }}</span>
                  </a-list-item>
                </a-list>
              </a-tab-pane>
              <router-link
                class="see-more"
                slot="tabBarExtraContent"
                :to="{ path: '/cms/list', query: { type: cmsType } }"
                >查看更多>></router-link
              >
            </a-tabs>
          </a-card>
        </a-col>
        <a-col
          :xs="24" :sm="24" :md="24" :lg="8" :xl="8"
          class="animate__animated animate__bounceInRight">
          <a-card
            class="column-card video-card box-shadow"
            :bordered="false"
            style="min-height: 430px"
          >
            <a-row type="flex" justify="space-between">
              <a-col :span="12"><h3>精彩影像</h3></a-col>
              <a-col :span="12">
                <router-link class="see-more" to="/cms/video">
                  查看更多>>
                </router-link>
              </a-col>
            </a-row>
            <br>
            <a-list
              :grid="{ gutter: 16, xl:2, lg: 2, md: 4, sm: 2, xs: 1}"
              :data-source="videoDataSource"
            >
              <a-list-item slot="renderItem" slot-scope="item">
                <div @click="toVideoDetail(item)">
                  <div class="img-zoom">
                    <img class="cover" :src="item.cmsCover_url" alt="" />
                  </div>
                  <a style="display:block;height:3em;"><h3 class="title">{{ item.cmsTitile }}</h3></a>
                </div>
              </a-list-item>
            </a-list>
          </a-card>
        </a-col>
      </a-row>
      <div class="hot-event">
        <h1>热门活动</h1>
      </div>
      <a-row
        type="flex"
        style="text-align: center"
        justify="space-between"
        :gutter="24"
      >
        <a-col :xs="24" :sm="24" :md="24" :lg="16" :xl="16">
          <h1 style="font-weight: 700; font-size: 24px; color: #fff" @click="toEventDetail(homeEventInfo)">
            {{homeEventInfo.eventName}}&nbsp;
          </h1>
          <PhotoCard >
            <img
              @click="toEventDetail(homeEventInfo)"
              slot="img"
              :src="homeEventInfo.eventCover_url"
              alt=""
              style="width: 100%; height: 300px; border-radius: 10px"
            />
            <div
              @click="toEventDetail(homeEventInfo)"
              slot="content"
              class="event-desc">
              <div v-html="homeEventInfo.eventDesc"></div>
            </div>
          </PhotoCard>
        </a-col>
        <a-col :xs="24" :sm="24" :md="24" :lg="8" :xl="8">
          <a-card class="user-card" style="margin-top: 40px" :bordered="false">
            <div>
              <a-row class="user" type="flex" justify="center" align="middle">
                <a-col :span="10">
                  <img class="avatar" :src="avatarUrl" alt="">
                  
                </a-col>
                <a-col :span="10">
                  <div v-if="$store.state.user.info">
                    <h3 class="username">{{ $store.state.user.info.realname }}</h3>
                    <a-button
                      class="login-btn"
                      @click="showApplyEvent"
                      >活动报名</a-button>
                    <!-- <a-button class="login-btn" @click="toCenter">申请证件</a-button> -->
                  </div>
                  <div v-else>
                    <h3 class="no-login">您还没有登录</h3>
                    <a-button class="login-btn" @click="toLogin">登录</a-button>
                  </div>
                </a-col>
              </a-row>
              <br />
              <div class="info">
                <p>地点：{{homeEventInfo.eventAddress}}</p>
                <p>时间：{{homeEventInfo.eventBegin}}</p>
                <!-- <a-row>
                  <a-col :span="12"><a-button @click="toCertQuery">证书查询</a-button></a-col>
                  <a-col :span="12"><a-button>问卷调查</a-button></a-col>
                </a-row> -->
              </div>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- <a-divider/> -->
      <h1 class="sec-title" v-if="timeline.length>0">日程安排</h1>
      <div class="animate__animated animate__fadeIn" v-if="timeline.length>0">
        <vue-horizontal-timeline
          timelineBackground="transparent"
          :items="timeline"
        />
      </div>
      <h1 v-if="storeDataSource.length>0" class="sec-title">故事分享</h1>
      <div v-if="storeDataSource.length>0" class="store">
        <a-list
          :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 4, sm: 2, xs: 1 }"
          :dataSource="storeDataSource"
        >
          <a-list-item
            class="store-item animate__animated animate__fadeIn"
            slot="renderItem"
            slot-scope="item"
            @click="toCmsDetail(item)"
          >
            <div class="img-zoom">
              <img class="cover" :src="item.cmsCover_url" alt="" />
            </div>
            <h3 class="title">{{ item.cmsTitile }}</h3>
          </a-list-item>
        </a-list>
      </div>

      <!-- <a-divider/> -->
      <h1 v-if="peopleDataSource.length>0" class="sec-title">科普名人堂</h1>
      <router-link
          v-if="peopleDataSource.length>0"
          class="see-more"
          style="color:#fff"
          slot="tabBarExtraContent"
          :to="{ path: '/cms/people' }"
          >查看更多>></router-link
        >
        <br />
      <div v-if="peopleDataSource.length>0" class="people">
        <a-list
          :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 4, sm: 2, xs: 1 }"
          :dataSource="peopleDataSource"
        >
          <a-list-item
            class="animate__animated animate__fadeIn people-item"
            slot="renderItem"
            slot-scope="item"
          >
            <div class="people" @click="toCmsDetail(item)">
              <a-avatar class="avatar" :size="100" :src="item.cmsCover_url" alt=""/>
              <div class="title"><h2>{{ item.cmsTitile }}</h2><span>院士</span></div>
              <p class="view-num">浏览数：451</p>
              <div class="domain">
                <p>领域</p>
                <p>机器人编程、在线教学等</p>
              </div>
            </div>
            <!-- <h3 class="title">{{ item.cmsTitile }}</h3> -->
          </a-list-item>
        </a-list>
      </div>

      <!-- <a-divider/> -->
      <div v-if="picDataSource.length>0" class="animate__animated animate__fadeIn">
        <h1 class="sec-title">往届回顾</h1>
        <router-link
          class="see-more"
          style="color:#fff"
          slot="tabBarExtraContent"
          :to="{ path: '/cms/pic' }"
          >查看更多>></router-link
        >
        <br />
        <br />
      </div>
      <div v-if="picDataSource.length>0" class="event-pic">
        <swiper
          ref="mySwiper"
          :options="swiperOptions"
          class="swiper-wrappe carousel"
        >
          <swiper-slide
            class="swiper-slide"
            v-for="(b, i) in picDataSource"
            :key="i"
          >
            <img :src="b.cmsCover_url" alt="" @click="toPicDetail(b)"/>
          </swiper-slide>

          <!-- 分页器 -->
          <div
            v-show="oldEventPic && oldEventPic.length > 1"
            class="swiper-pagination swiper-pagination-white"
            slot="pagination"
          ></div>
          <!-- 左右箭头 -->
          <div
            v-show="oldEventPic && oldEventPic.length > 1"
            class="swiper-button-prev swiper-button-white"
            slot="button-prev"
          ></div>
          <div
            v-show="oldEventPic && oldEventPic.length > 1"
            class="swiper-button-next swiper-button-white"
            slot="button-next"
          ></div>
        </swiper>
      </div>
      <br />
      <div v-if="videoDataSource.length" class="event-video">
        <router-link
          class="see-more"
          style="color:#fff"
          slot="tabBarExtraContent"
          :to="{ path: '/cms/video' }"
          >查看更多>></router-link
        >
        <br />
        <a-list
          :grid="{ gutter: _isMobile() ? 12 : 24, lg: 4, md: 4, sm: 2, xs: 1 }"
          :dataSource="videoDataSource"
        >
          <a-list-item
            class="animate__animated animate__fadeIn"
            slot="renderItem"
            slot-scope="item"
          >
            <div class="img-zoom" @click="toVideoDetail(item)">
              <img class="cover" :src="item.cmsCover_url" alt="" />
            </div>
            <!-- <h3 class="title">{{ item.cmsTitile }}</h3> -->
          </a-list-item>
        </a-list>
      </div>
    </div>
    <a-modal
      :width="800"
      :visible="videoVisible"
      :maskClosable="false"
      :title="currentVideo.cmsTitile"
      :destroyOnClose="true"
      @cancel="videoVisible = false"
      :footer="null"
    >
      <video
        style="width: 100%"
        controls
        autoplay
        oncontextmenu="return false;"
        controlsList='nodownload noremote footbar'
        :src="currentVideo.extraFile_url"
      ></video>
    </a-modal>
    <EventApplyModal ref="applyModal"/>
    <LightBox :showLightBox="false" ref="lightbox" :showCaption="true" :media="lightBoxMedia"></LightBox>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG, ACCESS_TOKEN } from "@/store/mutation-types";
import { getAction, postAction } from "@/api/manage";
import { getArticleList } from "@/api/article";
import { mixinDevice } from "@/utils/mixin.js";
import { getInfo } from "@/api/login";
import EventApplyModal from "./modal/EventApplyModal";
import PhotoCard from "@/components/common/PhotoCard";
import ImageButton from "@/components/common/ImageButton"
import "@/assets/less/animation.css";
import VueHorizontalTimeline from "@/components/common/VueHorizontalTimeline";
import LightBox from 'vue-image-lightbox'
import { jumpMixins } from "@/utils/jumpMixins"
require('vue-image-lightbox/dist/vue-image-lightbox.min.css')

export default {
  name: "Home",
  mixins: [mixinDevice, jumpMixins],
  components: {
    PhotoCard,
    VueHorizontalTimeline,
    LightBox,
    ImageButton,
    EventApplyModal
  },
  data() {
    return {
      articleList: [],
      videoVisible: false,
      currentVideo: {},
      cmsDataSource: [],
      cmsType: 1,
      videoDataSource: [],
      picDataSource:[],
      tenantConfig: {},
      token: "",
      peopleDataSource: [],
      storeDataSource:[],
      homeEventInfo: {},
      timeline: [],
      swiperOptions: {
        speed: 800,
        effect: this._isMobile()?"fade":"slide", //"slide" "fade"（淡入）、"cube"（方块）、"coverflow"（3d流）、"flip"（3d翻转）
        slidesPerView: 3,
        centeredSlides: true,
        coverflowEffect: {
          rotate: 0,
          stretch: 0,
          depth: 700,
          modifier: 0.5,
          slideShadows: false,
        },
        //显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        //设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        //自动轮播
        autoplay: {
          delay: 3000,
          //当用户滑动图片后继续自动轮播
          disableOnInteraction: true,
        },
        //开启循环模式
        loop: true,
      },
      oldEventPic: [
      ],
      lightBoxMedia: []
    };
  },
  created() {
    this.tenantConfig = this.$store.getters.tenantInfo;
    this.getHomeEvent();
    this.getVideoList();
    this.getPicList();
    this.getCmsList(1);
    this.getPeopleList();
    this.getStoreList();
  },
  mounted() {
  },
  computed:{
    avatarUrl(){
      return (this.$store.state.user.info && this.$store.state.user.info.avatar)?
      "https://cast-files.oss-cn-beijing.aliyuncs.com/" + this.$store.state.user.info.avatar : require("../assets/avatar1.png")
    }
  },
  methods: {
    tabChange(key) {},
    getUserInfo() {
      getInfo().then((res) => {
        console.log(res);
      });
    },
    showApplyEvent() {
      if (Vue.ls.get(ACCESS_TOKEN)) {
        // this.$refs.applyModal.open(this.homeEventInfo.id);
        this.$router.push({path: "/event/apply", query: {id:this.homeEventInfo.id}});
      } else {
        this.toLogin();
      }
    },
    getHomeEvent(){
      getAction("/teaching/teachingEvent/getHomeEvent").then(res=>{
        if(res.success){
          this.homeEventInfo = res.result
          this.timeline = this.homeEventInfo.teachingEventScheList.map(s=>{
            return {
              content: s.scheTime,
              title: s.scheDesc
            }
          })
        }else{
          this.$message.info(res.message);
        }
      })
    },
    toEventDetail(item) {
      let route = this.$router.resolve({
        path: "/event/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, "_blank");
    },
    getCmsList(type) {
      this.cmsType = type;
      this.cmsDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: type,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.cmsDataSource = res.result.records;
        }
      });
    },
    toCmsDetail(item) {
      let route = this.$router.resolve({
        path: "/cms/detail",
        query: {
          id: item.id,
        },
      });
      window.open(route.href, '_blank');
    },
    toCertQuery() {
      let route = this.$router.resolve({
        path: "/cert/query",
      });
      window.open(route.href, '_blank');
    },
    getVideoList() {
      this.videoDataSource = []
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 5,
        pageSize: 4,
      }).then((res) => {
        if (res.success) {
          this.videoDataSource = res.result.records;
        }
      });
    },
    getPicList(){
      getAction("/teaching/teachingCms/getCmsList", {
        cmsStatus: 1,
        cmsType: 10,
        pageSize: 10,
      }).then((res) => {
        if (res.success) {
          this.picDataSource = res.result.records;
          this.oldEventPic = this.picDataSource.map(i=>{
            return {
              img: i.cmsCover_url,
              href: "#"
            }
          })
        }
      });
    },
    getPeopleList() {
      this.peopleDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 7,
        pageSize: 4,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          //this.peopleDataSource = res.result.records;
        }
      });
    },
    getStoreList(){
      this.storeDataSource = [];
      getAction("/teaching/teachingCms/getCmsList", {
        cmsType: 4,
        pageSize: 4,
        cmsStatus: 1,
      }).then((res) => {
        console.log(res);
        if (res.success) {
          this.storeDataSource = res.result.records;
        }
      });
    },
    toVideoDetail(item) {
      this.currentVideo = item;
      this.videoVisible = true;
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id)
    },
    toPicDetail(item){
      //使阅读量+1
      getAction("/teaching/teachingCms/getCmsDetail?id=" + item.id)
      let that = this
      let fileNames = []
      if(item.extraFilename){
        fileNames = JSON.parse(item.extraFilename)
        console.log(fileNames);
      }
      if(item.extraFile){
        this.lightBoxMedia = item.extraFile.split(",").map(f=>{
          let fn = ""
          if(f in fileNames){
            fn = fileNames[f]
          }
          return {
            thumb: that.getQiniuUrl(f),
            src: that.getQiniuUrl(f),
            caption: fn
          }
        })
        this.$refs.lightbox.showImage(0)
      }else{
        //this.$message.warning("没有图像")
      }
    },
    getQiniuUrl(text){
      if(!text){
        this.$message.warning("未知的文件")
        return;
      }
      if(text.indexOf(",")>0){
        text = text.substring(0,text.indexOf(","))
      }
      if(text.startsWith("http")){
        return text
      }
      return this.tenantConfig.qiniuDomain + "/" + text;
    },
  },
};
</script>

<style lang="less" scoped>
.box-shadow {
  box-shadow: #67aaff99 0px 0px 6px 0px;
}
.sec-title {
  margin: 20px auto;
  width: 300px;
  height: 57px;
  display: block;
  text-align: center;
  line-height: 57px;
  font-weight: 700;
  font-size: 24px;
  color: #ffffff;
  text-shadow: #000 0px 0px 4px;
  background: url('~@assets/theme/aice/act-title-bg.png') no-repeat;
  background-size: 100% 100%;
}
.column-card {
  border-radius: 10px;
  margin-bottom: 5px;
  .cms-item {
    cursor: pointer;
    transition: color 0.2s;
  }
  .cms-item:hover {
    color: #1890ff;
  }
  .cms-title {
    width: 80%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .cms-time {
    text-align: right;
    width: 150px;
  }
}

.video-card {
  .cover {
    width: 100%;
    height: 120px;
    // max-height: 140px;
  }
}
.see-more {
  color: #999;
  text-align: right;
  float: right;
}
.see-more:hover {
  color: #1890ff;
}
.container {
  .home {
    max-width: 1200px;
    margin: 30px auto;
    .zhuanti {
      .zhuanti-item {
        margin: auto;
      }
      margin-bottom: 50px;
    }
    .news {
      height: 50px;
    }
    .event-desc{
      width: 40%;
      margin: auto;
      background-color: #0000008f;
      border-radius: 20px;
      padding: 10px;
      /deep/ *{
        background-color: unset!important;
      }
    }
    .common-title {
      h3 {
        font-size: 24px;
        font-weight: normal;
        line-height: 24px;
      }
    }

    .item-card {
      cursor: pointer;
      /deep/.ant-card-body {
        padding: 0;
        margin-top: 0;
        margin-bottom: 25px;
      }
      .cover {
        width: 100%;
        height: 170px;
        margin-bottom: 10px;
      }
    }
    .title {
      color: gray;
      font-size: 15px;
      line-height: 22px;
      margin-bottom: 0;
      overflow: hidden;
    }
    .title:hover {
      color: #1890ff;
    }
  }
  .event-pic {
    margin-bottom: 20px;
  }
  .event-video {
    margin-top: 20px;
    .img-zoom {
      height: 180px;
      border: rgb(192, 192, 192) solid 1px;
      border-radius: 5px;
      .cover {
        height: 100%;
        width: 100%;
      }
    }
  }
  .hot-event{
    background-image: url(../assets/hot-event-bg.png);
    background-repeat: no-repeat;
    height: 70px;
    margin-top: 3rem;
    h1{
      color: #fff;
      font-weight: 600;
      position: relative;
      left: 40px;
      line-height: 70px;
    }
  }
  .user-card{
    height: 320px;
    background: url(../assets/user-bg.png) no-repeat;
    background-size: 100% 100%;
    p,h3{
      color: #fff;
    }
    .user{
      height: 140px;
      .username{
        margin: 10px 0;
      }
      .login-btn{
        display: block; 
        margin: 5px auto;
        width: 100px;
        border-radius: 10px;
        color: rgb(238,11,241);
        font-weight: 600;
        font-size: 15px;
      }
      .avatar{
        max-width: 100px;
      }
    }
    .info{
      position: relative;
      bottom: 0px;
      .ant-btn{
        border: solid 1px white;
        background: transparent;
        color: white;
        border-radius: 20px;
      }
    }
  }
  .store {
    margin-top: 20px;
    .ant-card {
      height: 220px;
    }
    .store-item {
      height: 250px;
      overflow: hidden;
      .cover {
        height: 180px;
        width: 100%;
      }
      .title {
        color: #fff;
      }
    }
  }
  .people {
    margin-top: 20px;
    .avatar {
      margin-bottom: 20px;
    }
    .people-item{
      .people{
        width: 220px;
        height: 300px;
        margin: auto;
        padding: 20px 0;
        background: url('../assets/people-bg.png') no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
      .avatar{
        border: solid 1px rgb(98,252,252);
      }
      .title{
        h2{
          display: inline-block;
          font-weight: 700;
        }
        span{
          display: inline-block;
          color: black;
          margin-left: 8px;
        }
      }
      .view-num{
        color: gray;
      }
      .domain{
        border-radius: 50px;
        color: rgb(34,142,249);
        background: rgb(226,236,246);
        padding: 5px;
        margin: 0 20px;
        p{
          margin-bottom: 0;
        }
      }
    }
    cursor: pointer;
    text-align: center;
  }
}

.vue-horizontal-timeline {
  box-shadow: none !important;
  /deep/.timeline {
    overflow-x: auto;
  }
  /deep/.timeline::-webkit-scrollbar {
    width: 10px;
    background-color: #F5F5F5;
  }
  /deep/.timeline::-webkit-scrollbar-thumb {
    background-color: rgb(27, 110, 219);
    background-image: -webkit-linear-gradient(45deg, rgba(255, 255, 255, .2) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, .2) 50%, rgba(255, 255, 255, .2) 75%, transparent 75%, transparent);
  }
}

.carousel {
  max-height: 400px;
  .swiper-slide{
    background: url(../assets/img-board.png) no-repeat;
    background-size: 100% 100%;
    padding: 15px 20px;
    transition: 300ms;
    transform: scale(0.6);
  }
  .swiper-slide-active,.swiper-slide-duplicate-active{
      transform: scale(1);
	}
  img {
    max-height: 500px;
    width: 100%;
    // width: 100%;
  }
}

.mobile {
  .item-card {
    /deep/.ant-card-body {
      margin-bottom: 12px !important;
    }
    .cover {
      height: 100px !important;
    }
  }
}
</style>